import { useContext, useMemo } from 'react'
import { SearchTypes } from '../providers/SearchProfilesPage/types'
import { SearchProfilesPageContext } from '../providers/SearchProfilesPage'
import { SpecialistProfile } from '../types/specialist'
import { PracticeProfile } from '../types/practice'

export default function useGetProfilesToShow(): Array<SpecialistProfile | PracticeProfile> {
  const {
    state: { specialists, practices, filters }
  } = useContext(SearchProfilesPageContext)

  return useMemo(
    () =>
      filters.searchType === SearchTypes.specialists || filters.searchType === SearchTypes.healthAndSocialCare
        ? specialists
        : practices,
    [filters.searchType, practices, specialists]
  )
}
